import { CoreIcon } from '../core-icon';
import mapPinSVG from '../../assets/icons/map-pin.svg';
import type { IconProps } from '../core-icon';

export const MapPinIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={mapPinSVG} {...props} />;
};
